<template>
  <!-- 设备所属采集器 -->
  <div class="devicebelong" v-show="showDevicebelong">
    <div class="essentialInfo">
      <div class="closepage" @click="showDetail"></div>
      <!-- info -->
      <div style="width:100%">
        <devicebelongoperate
          :dataloggerInfo2="dataloggerInfo2"
          :activeTab="activeTab"
          @refreshBelong="handleRefreshBelong"
        ></devicebelongoperate>
        <!-- tabs -->
        <ul class="tab">
          <li class="tab-item"
            v-for="(value,key) in tabs"
            :key="key"
            :class="{active:activeTab==key}"
            @click="activeTab=key"
          >{{value}}</li>
        </ul>
      </div>
      
      
    </div>
    
    
    <!-- <component :is="activeTab" class="content"></component> -->
    <devicebelonginfo 
      :is="activeTab" 
      :dataloggerInfo1="dataloggerInfo1"
      :dataloggerInfo2="dataloggerInfo2"
    ></devicebelonginfo>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import devicebelongoperate from './devicebelongoperate';
import devicebelonginfo from './devicebelonginfo';
import devicebelonglist from './devicebelonglist';
export default {
  components: {
    devicebelongoperate,
    devicebelonginfo,
    devicebelonglist
  },
  data() {
    return { 
      // 显示本页
      showDevicebelong: true,
      tabs: {
        // 基本信息
        devicebelonginfo: this.$t('datalogger.basicInfo'),
        // this.$t('device.overview')
        // 连接信息
        devicebelonglist: this.$t('datalogger.connectionInfo'),
        
      },
      // 当前选中标签页序列号
      activeTab: 'devicebelonginfo',
      // 查看的数采器
      // previewDataloggerInfo: null,
      // 查看数采器对应设备表
      previewDeviceList: [],
      // 数采器信息
      dataloggerInfo1: {
        alias: "", 
        timezone: "", 
        address: {
          address: "",
          city: "",
          country: "",
          county: "",
          installDate: "",
          installer: "",
          lat: "",
          lon: "",
          province: "",
          timezone: "",
          town: "",
          village: "",
        },
        profit: {
          buyProfit: "",
          currency: "",
          nominalPower: "",
          sellProfit: "",
          unitProfit: "",
        },
      },
      dataloggerInfo2: {
        alias: "",
        balance: "",
        buyProfit: "",
        currency: "",
        descx: "",
        did: "",
        fireware: "",
        load: "",
        pn: "",
        sellProfit: "",
        signal: "",
        status: "",
        uid: "",
        unitProfit: "",
      }
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo',
      getIsShow: 'getIsShow'
    }),
  },
  watch: {
    deviceInfo(){
      this.getDataloggerInfo();
      // this.getDataloggerInfo2();
    },
  },
  created() {
    // this.queryDataloggerStatus();
    // this.getDataloggerList();
    // this.getDataloggerInfo();
    // console.log('local', this.deviceInfo);
    this.getDataloggerInfo();
    // this.getDataloggerInfo2();
  },
  beforeDestroy(){
    if (this.getIsShow.isShow==2) {
      this.$store.commit('saveIsShow', 1);
    }else if(this.getIsShow.isShow==3){
      this.$store.commit('saveIsShow', 3);
    }else if(this.getIsShow.isShow==4){
      this.$store.commit('saveIsShow', 4);
    }else{
      this.$store.commit('saveIsShow', 1);
    }
  },
  methods: {
    // 更新数采器修改后信息
    handleRefreshBelong() {
      // console.log("数采器修改成功通知更新");
      this.getDataloggerInfo();
      // this.getDataloggerInfo2();
    },
    // 显示详情页
    showDetail() {
      // this.$emit('showdetail', false);
      this.$store.commit('saveIsShow', 1);
    },
    // 查看数采器信息(1)
    // (设备：01352419520097 ; pn: 'Q0021280990582')
    getDataloggerInfo() {
      this.$request.get("queryCollectorinfoEs", { pn:this.deviceInfo.pn}).then(res => {
        if (res.err === 0) {
          // console.log('online-数采器信息1', res.dat);
          // this.dataloggerInfo1 = { pn:this.deviceInfo.pn, ...res.dat };
          this.dataloggerInfo1 = res.dat;
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 查看数采器信息(2)
    getDataloggerInfo2() {
      let param = {
        pn: this.deviceInfo.pn
      };
      this.$request.get("webQueryCollectorsEs", param).then(res => {
        if (res.err === 0) {
          // console.log('online-数采器信息2', res.dat.collector[0]);
          this.dataloggerInfo2 = res.dat.collector[0];
        } else {
          this.$message.warning(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 查看数采器对应设备
    // previewDatalogger(info) {
    //   // this.previewDataloggerInfo = {
    //   //   pn: info.pn,
    //   //   alias: info.alias || info.pn
    //   // };
    //   let param = {
    //     pn: info.pn,
    //     devtype: 2304,
    //     page: 0,
    //     pagesize: 50
    //   };
    //   this.loadingPreviewDevice = true;
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err === 0) {
    //       this.previewDeviceList = res.dat.device;
    //     } else {
    //       this.previewDeviceList = [];
    //     }
    //     this.loadingPreviewDevice = false;
    //   });
    // },
    // 点击进入设备
    // enterDevice(info) {
    //   this.$store.commit("saveDeviceInfo", {
    //     pn: info.pn,
    //     sn: info.sn,
    //     devcode: info.devcode,
    //     devaddr: info.devaddr
    //   });
    // },
  }
}
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');
.devicebelong {
  // position: relative;
  // margin-left: 50px;
  // 关闭本页
  .essentialInfo{
    width: 100%;
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
    display: flex;
    .closepage {
      background-color: #41505a;
      width: 60px;
      height: 103px;
      background-image: url('../../../../assets/img/general/arrow_left.png');
      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }
  }
  
  .tab {
    display: flex;
    background: rgb(34, 45, 53);
    // border-top: 1px dashed rgba(47, 92, 76, 1);
    &-item {
      margin: 0px;
      // padding: 12px 32px;
      padding: 1vh 32px;
      .sc(16px, rgb(123, 131, 149));
      // background: rgba(43, 56, 66, 1);
      background: rgba(34, 45, 53, 1);
      border-bottom: none;
      cursor: pointer;
      &:hover {
        background: #215E53;
        color: #ffffff;
      }
      &.active {
        color: #33ffb6;
        background: rgba(34, 45, 53, 1);
        border-bottom: 1px solid #33ffb6;
      }
    }
  }
  .content {
    flex: 1;
    display: flex;
    // flex-direction: row;
    height: 550px;
  }
}
</style>